export const initialiseFilterKeyword = (widget: HTMLElement) => {
    moveKeyword(widget)

    const searchInput = widget.querySelector<HTMLInputElement>('.search-filters-widget__filter-search-input')
    if (!searchInput) return
    enableSearchOnEnter(searchInput)
    clearSearchOnInputClear(widget, searchInput)
}

const moveKeyword = (widget: HTMLElement) => {
    const keyword = widget.querySelector<HTMLElement>('#keyword-option-wrapper')
    if (!keyword) return
    
    const container = document.querySelector<HTMLElement>('.job-results__hero')
    container?.append(keyword)
}

const enableSearchOnEnter = (searchInput: HTMLInputElement) => {
    searchInput.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            const parentElement = searchInput.closest<HTMLDivElement>('.search-filters-widget__filter-search')
            const searchButton = parentElement?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
            searchButton?.click()
        }
    })
}

const clearSearchOnInputClear = (widget: HTMLElement, searchInput: HTMLInputElement) => {
    const searchButton = widget?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
    if (!searchButton) return

    searchInput.addEventListener('input', () => {
        if (searchInput.value === '') {
            searchButton?.click()
        }
    })
}